import { DomainRule } from '../../types';

export interface FrequencyRequiredRuleDto {
  frequency: string;
}

export const FrequencyRequiredRuleKey = 'frequencyRequired';

export const FrequencyRequiredRule = (dto: FrequencyRequiredRuleDto): DomainRule => {
  if (!dto?.frequency) {
    return {
      result: 'fail',
      ruleKey: 'frequencyRequired',
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
